//====================================================
//  Initialization Map
//====================================================


function fn_components_map(){
    if ($('#sellers_map').length){
        fn_components_map_init('sellers_map');
    }
    
    if ($('#footer_map').length){
        fn_components_map_init('footer_map');
    }


}

 // if ($('#sellers_map').length){
 //        var waypoint = new Waypoint({
 //            element: document.getElementById('sellers_map'),
 //            handler: function() {
 //                fn_components_map_init('sellers_map');
 //            },
 //            offset: '100%'
 //        })
 //    }
    


function fn_components_map_init(mapId){
	var map
    var mapOptions = {
        zoom: 13,
        panControl: false,
        zoomControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        scrollwheel: false,
        //draggable: false,
        center: new google.maps.LatLng(50.0809813, 14.396636),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
    };
    map = new google.maps.Map(document.getElementById(mapId), mapOptions);

    var gmarkers = [];
    var bounds = new google.maps.LatLngBounds();
    var imageSrc = "public/img/nase-prodejny.png";

    var defaultIcon = new google.maps.MarkerImage(
        imageSrc,
        null, 
        null, 
        null, 
        new google.maps.Size(34, 47)
    );


    var zoomControlDiv = document.createElement('div');
    zoomControlDiv.className = "zoom-block"
    var zoomControl = new fn_customZoomControl(zoomControlDiv, map, mapId);
    map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(zoomControlDiv);

    var markers = {
        "count": 5,
        "marker": [{
            "id": '1',
            "type": '1',
            "icon": 'public/img/nase-prodejny.png',
            "name": "Prodejna Praha 6 <br> Jílová 25, 775 66 <br> <br> Po - Pá: 08:00 - 17:00",
            "longitude": 50.091922,
            "latitude": 14.423461
        }, {
            "id": '2',
            "type": '2',
            "icon": 'public/img/retailove-prodejny.png',
            "name": "Prodejna Praha 24 <br> Jílová 25, 775 66 <br> <br> Po - Pá: 08:00 - 20:00 <br> Po - Pá: 08:00 - 20:00 <br> Po - Pá: 08:00 - 20:00 <br> Po - Pá: 08:00 - 20:00",
            "longitude": 50.090564,
            "latitude": 14.413077
        }, {
            "id": '3',
            "type": '3',
            "icon": 'public/img/zahranicni-distributory.png',
            "name": "Prodejna Praha 6 <br> Jílová 25, 775 66",
            "longitude": 50.090802,
            "latitude": 14.463077
        }, {
            "id": '4',
            "type": '2',
            "icon": 'public/img/retailove-prodejny.png',
            "name": "Prodejna Praha 6 <br> Jílová 25, 775 66 <br> <br> Po - Pá: 08:00 - 17:00",
            "longitude": 50.110702,
            "latitude": 14.403077
        }, {
            "id": '5',
            "type": '1',
            "icon": 'public/img/nase-prodejny.png',
            "name": "Prodejna Praha 6",
            "longitude": 50.099702,
            "latitude": 14.463077
        }

        ]
    }
    for (var i = 0; i < markers.count; ++i) {
        var latLng = new google.maps.LatLng(markers.marker[i].longitude, markers.marker[i].latitude)
        

        var marker = new google.maps.Marker({
            position: latLng,
            draggable: false,
            icon: markers.marker[i].icon,
            id: markers.marker[i].id,
            type: markers.marker[i].type,
            name: markers.marker[i].name
        });

        var infoWindow = new google.maps.InfoWindow({
            pixelOffset: new google.maps.Size(109,60),
            maxWidth: 200
        }), marker, i;

        google.maps.event.addListener(marker, 'click', function(e){
            if (this.id.length){
                infoWindow.setContent('<p>' + this.name + '</p>');
                infoWindow.open(map, this);
                $('.gm-style-iw').parent().addClass('window-block');
                fn_setBackgroundColor(this.type);
            }
        });

        google.maps.event.addListener(marker, 'mouseover', function(e){
            if (this.id.length){
                infoWindow.setContent('<p>' + this.name + '</p>');
                infoWindow.open(map, this);
                $('.gm-style-iw').parent().addClass('window-block');
                fn_setBackgroundColor(this.type);
            }
        });

        google.maps.event.addListener(marker, 'mouseout', function(e){
            // for (var i = 0; i < gmarkers.length; i++) {
            //     gmarkers[i].setIcon(defaultIcon);
            //     infoWindow.close();
            // }
        });

        bounds.extend(marker.position);
        marker.setMap(map);
        gmarkers.push(marker);
    }



    google.maps.event.addListener(map, "click", function () {
        for (var i=0; i < gmarkers.length; i++) {
            infoWindow.close();
        }
     });

    map.fitBounds(bounds);
}


function fn_customZoomControl(controlDiv, map, mapId) {
    var controlUIzoomIn= document.querySelector('#'+ mapId + ' + .zoom-block #zoom-in'),
    controlUIzoomOut= document.querySelector('#'+ mapId + ' + .zoom-block #zoom-out')
    controlDiv.appendChild(controlUIzoomIn);
    controlDiv.appendChild(controlUIzoomOut);
    google.maps.event.addDomListener(controlUIzoomIn, 'click', function() {
        map.setZoom(map.getZoom()+1)
    });
    google.maps.event.addDomListener(controlUIzoomOut, 'click', function() {
        map.setZoom(map.getZoom()-1)
    });
}


function fn_setBackgroundColor(type){
    var backgroundClass;
    if (type == 1) backgroundClass = "bg-our";
    if (type == 2) backgroundClass = "bg-retail";
    if (type == 3) backgroundClass = "bg-foreign";
    $('.gm-style-iw').parent().removeClass().addClass('window-block ' + backgroundClass);
}